import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

/**
 * Password input with a toggle to show/hide the value.
 *
 * Reusable across Register / Login / TeacherSettings / ResetPassword so
 * every form behaves identically. Passes all standard input props through
 * (id, value, onChange, minLength, required, placeholder, autoComplete,
 * disabled, name, className). The eye icon toggles `type` between
 * "password" and "text" — never mirrors state to the DOM as plain text
 * unless the user explicitly requests it.
 */
export default function PasswordInput({ className = "", ...props }) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <input
        {...props}
        type={visible ? "text" : "password"}
        className={`w-full pr-12 ${className}`}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 rounded-md hover:bg-[#F1F5F9] focus:outline-none focus:ring-2 focus:ring-[#0F172A]"
        aria-label={visible ? "Ukryj hasło" : "Pokaż hasło"}
        title={visible ? "Ukryj hasło" : "Pokaż hasło"}
        data-testid={`${props.id || "password"}-toggle-visibility`}
      >
        {visible
          ? <EyeOff className="w-4 h-4" strokeWidth={2.5} />
          : <Eye className="w-4 h-4" strokeWidth={2.5} />}
      </button>
    </div>
  );
}
